module.exports = __webpack_public_path__ + "img/orchid3.9f98129d.jpg";